import { Color, Spacing } from '@persona-id/design-tokens';
import { ReactNode } from 'react';
import { MEDIA_WIDTHS, mediaQuery } from 'shared/styles/variables';
import styled from 'styled-components';

import Spacer from 'design-system/components/Spacer';
import { BASE } from 'design-system/variables/spacing';
import LogoLight from 'images/brand/logo-color-light.svg';

const Container = styled('div')`
  width: 100%;
  height: 100vh;
  display: flex;
  flex-direction: row;
`;

const SectionLeft = styled('div')`
  display: flex;
  justify-content: center;
  overflow-y: auto;
  width: 100%;
  padding: ${Spacing[6]};
  background-color: ${({ theme }) => theme.color.background.primary};

  @media ${mediaQuery({ min: MEDIA_WIDTHS.desktop })} {
    padding: ${BASE * 10}px;
    width: 50%;
  }
`;

const Contents = styled('div')`
  width: 100%;
  max-width: 480px;
`;

const Logo = styled(LogoLight)`
  width: 128px;
  height: auto;
`;

const SectionRight = styled('div')`
  display: none;

  @media ${mediaQuery({ min: MEDIA_WIDTHS.desktop })} {
    display: flex;

    position: relative;
    width: 50%;
    overflow: hidden;
    justify-content: center;

    padding: ${BASE * 10}px;
  }
`;

const PositionedBackground = styled.div`
  background-color: ${Color.CorePurple300};
  position: absolute;
  top: 0px;
  min-width: 100%;
  min-height: 100%;
  height: auto;
  width: auto;
  z-index: -1;
`;

interface UnauthenticatedPageProps {
  children: ReactNode;
}

const UnauthenticatedPage = ({ children }: UnauthenticatedPageProps) => {
  return (
    <Container>
      <SectionLeft>
        <Contents>
          <Logo />

          <Spacer height={7.5} />

          {children}
        </Contents>
      </SectionLeft>

      <SectionRight>
        <PositionedBackground />
      </SectionRight>
    </Container>
  );
};

export default UnauthenticatedPage;
